import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=0dd9e082&scoped=true"
import script from "./Editor.vue?vue&type=script&lang=ts"
export * from "./Editor.vue?vue&type=script&lang=ts"
import style0 from "./Editor.vue?vue&type=style&index=0&id=0dd9e082&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd9e082",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dd9e082')) {
      api.createRecord('0dd9e082', component.options)
    } else {
      api.reload('0dd9e082', component.options)
    }
    module.hot.accept("./Editor.vue?vue&type=template&id=0dd9e082&scoped=true", function () {
      api.rerender('0dd9e082', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/Editor.vue"
export default component.exports